// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import { AuthProvider } from './context/AuthContext';
// import { OrderProvider } from './context/OrderContext';
// import './global.css';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <AuthProvider>
//       <OrderProvider>
//     <App />
//     </OrderProvider>
//     </AuthProvider>
//   </React.StrictMode>
// );


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { OrderProvider } from './context/OrderContext';
import './global.css';



// ⬇️ ADD THIS
import { MantineProvider } from "@mantine/core";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <MantineProvider>
    <React.StrictMode>
    {/* MantineProvider MUST wrap the whole application */}
    
      <AuthProvider>
        <OrderProvider>
          <App />
        </OrderProvider>
      </AuthProvider>
    </React.StrictMode>
  </MantineProvider>
);
